<script setup lang="ts">
definePageMeta({ layout: 'custom' })
const { t } = useI18n()
useSeoMeta({
  title: t('TikTok数据分析平台&服务商-Gloda'),
  keywords: 'Gloda,tiktok数据,tiktok数据分析,tiktok数据分析平台,Gloda官网',
  description: 'Gloda是TikTok数据分析平台，提供tiktok电商数据分析、tiktok短视频数据分析、tiktok商品数据分析、tiktok达人分析、tiktok小店数据分析等，助力卖家实现高效选品、市场分析、甄选达人等。',
}, { tagPriority: 5 })
</script>

<template>
  <div class="privacy">
    <p>
      <br>
    </p>
    <p class="privacy__title MsoNormal" align="center" style="margin-left:0.0000pt;text-align:center;">
      <b>Privacy Terms</b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      &nbsp;&nbsp;&nbsp;We are committed to protecting and respecting your privacy. This policy explains our practices regarding the collection and use of personal data provided by you. We strive to express in plain and concise language and highlight in bold terms the clauses in this policy that are closely related to your rights for your attention. If you do not agree with this policy, you should not use this platform.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      &nbsp;&nbsp;&nbsp;If you have any questions about how we use your personal data, please contact us through the following means: <a class="href" href="https://seller.glodastory.com/" target="_blank"><u>https://seller.glodastory.com/</u></a>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b>(I) Information Collection </b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      In the process of registering as a Gloda product user and using Gloda products, Gloda will adhere to the principle of collecting the least amount of information necessary, and only collect your personal information within the necessary and limited scope. This information will only be used to create an account for you, provide services, or optimize Gloda products. In accordance with the above requirements, Gloda will collect the information that you actively provide or generate from using Gloda products in the following ways:
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.&nbsp;When registering for a Gloda product account, you need to provide Gloda with your email address, phone number, name of your organization, industry category, organization address, created username and password, etc. (collectively referred to as "basic information"), which is used to verify your registration qualifications and for Gloda to contact you when necessary.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.&nbsp;In the process of using Gloda products, Gloda may also collect your gender, ID number, address, educational background, photos, QQ account, WeChat account, Weibo account, work organization, position, work address, organization size and industry information. The aforementioned information will help Gloda provide you with better services and experiences.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      The information you provide will continue to be authorized for use by Gloda during the period in which you use Gloda products. This information will be stored within the territory of the People's Republic of China. If cross-border transfer is required, Gloda will separately obtain your authorization consent. When Gloda intends to use the above information for purposes not specified in this Policy Section 10, your consent will be sought in advance. Consent will also be sought in advance if Gloda intends to use information collected for specific purposes for other purposes.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b>(II) Personal Information Protection </b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.&nbsp;Gloda has implemented security measures that comply with industry standards to protect the personal information you provide, in order to prevent unauthorized access, disclosure, use, modification, damage, or loss of data. We will take all reasonable and feasible measures to protect your personal information. For example, Gloda will use encryption technology to ensure the confidentiality of data; employ trusted protection mechanisms to prevent data from malicious attacks; implement access control mechanisms to ensure that only authorized personnel can access personal information; and conduct security and privacy protection training courses to enhance employee awareness of the importance of protecting personal information.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.&nbsp;Gloda will take all reasonable and feasible measures to ensure that irrelevant personal information is not collected. Gloda will only retain your personal information for the period necessary to achieve the purposes stated in this Section 10, unless an extension of the retention period is required or allowed by law.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.&nbsp;The internet is not an absolutely secure environment, and email, instant messaging, and other related communication methods are not encrypted. Gloda strongly advises against sending personal information through such means. Please use complex passwords to assist Gloda in ensuring the security of your account; do not disclose your Gloda product account and password to others. If you discover any leakage of your personal information, especially your account or password, please contact Gloda immediately for appropriate measures to be taken according to your request.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      4.&nbsp;The internet environment is not entirely secure, and Gloda will make every effort to ensure or guarantee the security of any information you send to Gloda. If Gloda's physical, technical, or managerial protective measures are compromised, leading to unauthorized access, disclosure, alteration, or destruction of information, causing harm to your legitimate rights and interests, Gloda will bear corresponding legal responsibilities.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      5.&nbsp;In the unfortunate event of a personal information security incident, Gloda will promptly inform you in accordance with legal requirements: the basic situation and possible impacts of the security incident, the measures that Gloda has taken or will take, suggestions for you to independently prevent and reduce risks, and remedial measures for you. Gloda will timely inform you of the incident-related information via email, letter, telephone, push notifications, etc. In cases where it is difficult to inform each individual information subject, Gloda will announce in a reasonable and effective manner. Furthermore, Gloda will also proactively report the handling of personal information security incidents as required by regulatory authorities.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b>(III) Provision of Information to Third Parties </b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.&nbsp;Gloda will not share your personal information, except under the following circumstances:
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;Sharing with explicit consent: With your explicit consent, Gloda may share your personal information with others;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;Legal requirements: Gloda may share your personal information externally in accordance with legal regulations or mandatory requirements from government authorities;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;Sharing with affiliated companies: Your personal information may be shared with Gloda's affiliated companies, but Gloda will only share necessary personal information, subject to the purposes stated in this Section 10 policy. If Gloda's affiliated companies intend to change the processing purposes of personal information, they will seek your authorization consent again;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;Sharing with authorized partners: For the purposes stated in this Section 10 policy, certain services provided by Gloda may be carried out by authorized partners. Gloda may share some of your personal information with partners to enhance customer service and user experience. Gloda will only share your personal information for legitimate, necessary, specific, and explicit purposes and only the personal information necessary to provide services. Gloda's partners are not permitted to use the shared personal information for any other purposes.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      Companies, organizations, and individuals sharing personal information with Gloda will be required to sign strict confidentiality agreements with Gloda, requiring them to handle personal information in accordance with Gloda's instructions, this privacy policy, and any other relevant confidentiality and security measures.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.&nbsp;Gloda will not transfer your personal information to any company, organization, or individual, except under the following circumstances:
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;Transfer with explicit consent: With your explicit consent, Gloda may transfer your personal information to other parties;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;In cases involving mergers, acquisitions, or bankruptcy liquidations where the transfer of personal information is necessary, Gloda will require the new entity holding your personal information to continue to adhere to this privacy policy. Otherwise, Gloda will request the company or organization to seek your authorized consent again.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.&nbsp;We will only publicly disclose your personal information in the following situations:
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;With your explicit consent;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      •&nbsp;Based on legal disclosure: Gloda may disclose your personal information in cases where legal requirements, legal procedures, litigation, or mandatory requests from government authorities apply.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b>(IV) Privacy Policy Updates</b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      &nbsp;The privacy policy under this provision may be subject to changes, and Gloda will publish any changes made to the privacy policy on the official website of Gloda and the relevant pages of Gloda products. For significant changes, Gloda will provide more prominent notifications (including sending notifications via email for certain services, explaining the specific changes to the privacy policy).
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      Significant changes referred to above include but are not limited to:
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.&nbsp;Significant changes in the service model of Gloda products, such as the purpose of processing personal information, types of personal information processed, and methods of using personal information;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.&nbsp;Significant changes in ownership structures, organizational frameworks, such as owner changes resulting from business adjustments, bankruptcies, and mergers;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.&nbsp;Major changes in the main entities with whom personal information is shared, transferred, or publicly disclosed;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      4.&nbsp;Significant changes in your rights and their exercise methods regarding the processing of personal information.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b>(V) Other </b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.&nbsp;You are aware and agree that this privacy policy is an integral part of Gloda's relevant terms of service.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.&nbsp;Your access to or use of our services is also bound by the terms of our partners, including but not limited to <a class="href" href="https://www.tiktok.com/legal/page/global/tik-tok-developer-terms-of-service/en" target="_blank"><u>TikTok Developer Terms of Service</u></a>, which can be directly downloaded on our platform or our partner's platform.
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.&nbsp;If you have any questions, feedback, or requests regarding this policy, please contact us through the following means: <a class="href" href="https://seller.glodastory.com/" target="_blank"><u>https://seller.glodastory.com/</u></a>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <br>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <br>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p class="MsoNormal" align="center" style="margin-left:0.0000pt;text-align:center;">
      <b><span>隐私条款</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;text-indent:22pt;">
      <b><span>我们致力于保护和尊重您的隐私。本政策解释了关于我们从您那里收集或使用您提供给我们的个人数据的做法。我们努力用通俗易懂、简明扼要的文字进行表达，并对本政策中与您的权益密切相关的条款采用粗体字进行标注以提示您注意。如果您不同意本政策，则不应使用本平台。</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;text-indent:22pt;">
      <b><span>如果您对我们如何使用您的个人数据有任何疑问，请通过以下方式联系我们</span>:<a class="href" href="https://seller.glodastory.com/" target="_blank"><u>https://seller.glodastory.com/</u></a></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b><span>（一）信息收集</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;text-indent:11pt;">
      <span>在您注册成为</span>Gloda<span>产品用户及使用</span><span>Gloda</span><span>产品的过程中，</span><span>Gloda</span><span>将遵守最少够用原则，仅在必要及有限的范围内收集您的个人信息，并且这些信息仅用于为您创建账号、向您提供服务或优化</span><span>Gloda</span><span>产品。基于前述要求，</span><span>Gloda</span><span>将按照如下方式收集您主动提供或因为使用</span><span>Gloda</span><span>产品而产生的信息：</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.<span>在您注册</span><span>Gloda</span><span>产品账号时，需要向</span><span>Gloda</span><span>提供您的电子邮箱地址、手机号码，所在单位名称、行业类别、单位地址，创建的用户名和密码等信息（统称</span><span>“</span><span>基本信息</span><span>”</span><span>），用于确定您的注册资格以及必要时</span><span>Gloda</span><span>与您取得联系。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.<span>在您使用</span><span>Gloda</span><span>产品过程中，</span><span>Gloda</span><span>可能还会收集您集您的性别、身份证号码、住址、教育背景、照片、</span><span>QQ</span><span>账号、微信账号、微博账号、工作单位、工作职位、工作地址、所在单位规模及所处行业等信息。前述信息将有助于</span><span>Gloda</span><span>为您提供更好的服务和体验。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <span>您提供的上述信息，将在您使用</span>Gloda<span>产品期间持续授权</span><span>Gloda</span><span>使用。上述信息将存储于中华人民共和国境内，如需跨境传输，</span><span>Gloda</span><span>将会单独征得您的授权同意。当</span><span>Gloda</span><span>要将上述信息用于本第十条政策未载明的其它用途时，会事先征求您的同意。当</span><span>Gloda</span><span>要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b><span>（二）个人信息保护</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.Gloda<span>已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，</span><span>Gloda</span><span>会使用加密技术确保数据的保密性；</span><span>Gloda</span><span>会使用受信赖的保护机制防止数据遭到恶意攻击；</span><span>Gloda</span><span>会部署访问控制机制，确保只有授权人员才可访问个人信息；以及</span><span>Gloda</span><span>会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.Gloda<span>会采取一切合理可行的措施，确保未收集无关的个人信息。</span><span>Gloda</span><span>只会在达成本第十条政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.<span>互联网并非绝对安全的环境，而且电子邮件、即时通讯及与其他相关交流方式并未加密，</span><span>Gloda</span><span>强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助</span><span>Gloda</span><span>保证您的账号安全；请您不向他人泄露</span><span>Gloda</span><span>产品的账号和密码，如您发现自己的个人信息尤其是您的账号或密码发生泄露时，请您立即联络</span><span>Gloda</span><span>，以便</span><span>Gloda</span><span>根据您的申请采取相应合理措施。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      4.<span>互联网环境并非百分之百安全，</span><span>Gloda</span><span>将尽力确保或担保您发送给</span><span>Gloda</span><span>的任何信息的安全性。如果</span><span>Gloda</span><span>的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，</span><span>Gloda</span><span>将承担相应的法律责任。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      5.<span>在不幸发生个人信息安全事件后，</span><span>Gloda</span><span>将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、</span><span>Gloda</span><span>已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。</span><span>Gloda</span><span>将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，</span><span>Gloda</span><span>会采取合理、有效的方式发布公告。同时，</span><span>Gloda</span><span>还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b><span>（三）对外提供信息</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.Gloda<span>将不会分享您的个人信息， 但以下情况除外：</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (1)<b><span>在获取明确同意的情况下共享：获得您的明确同意后，</span></b>Gloda<b><span>会与其他方共享您的个人信息；</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (2)Gloda<b><span>可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息；</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (3)<b><span>与</span></b>Gloda<b><span>的关联方共享：您的个人信息可能会与</span></b>Gloda<b><span>的关联方共享，</span></b>(<span>但是，</span><span>Gloda</span><span>只会共享必要的个人信息，且受本第十条政策中所声明目的的约束；</span><span>Gloda</span><span>的关联方如要改变个人信息的处理目的，将再次征求您的授权同意；</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (4)<span>与授权合作伙伴共享：</span><b><span>仅为实现本第十条政策中声明的目的，</span></b>Gloda<b><span>的某些服务将由授权合作伙伴提供；</span>Gloda<span>可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验；</span></b>Gloda<span>仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息；</span><span>Gloda</span><span>的合作伙伴无权将共享的个人信息用于任何其他用途。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <span>对</span>Gloda<span>与之共享个人信息的公司、组织和个人，</span><span>Gloda</span><span>会与其签署严格的保密协定，要求他们按照</span><span>Gloda</span><span>的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2.Gloda<span>不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (1)<b><span>在获取明确同意的情况下转让：获得您的明确同意后，</span>Gloda<span>会向其他方转让您的个人信息；</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (2)<b><span>在涉及合并、收购或破产清算时，如涉及到个人信息转让，</span>Gloda<span>会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，</span></b><span>否则</span>Gloda<span>将要求该公司、组织重新向您征求授权同意。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.<span>我们仅会在以下情况下，公开披露您的个人信息：</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (1)<b><span>获得您明确同意后；</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (2)<b><span>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，</span></b>Gloda<span>可能会公开披露您的个人信息。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b><span>（四）隐私政策更新</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <span>本条款下的隐私政策可能会变更，</span>Gloda<span>将在数说故事官方网站、</span><span>Gloda</span><span>产品的相应页面上发布对隐私政策所做的变更。对于重大变更，</span><span>Gloda</span><span>还会提供更为显著的通知（包括对于某些服务，</span><span>Gloda</span><span>会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <span>上述所指的重大变更包括但不限于：</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (1)Gloda<span>产品的服务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (2)Gloda<span>在所有权结构、组织架构等方面发生重大变化，如业务调整、破产并购等引起的所有者变更等；</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (3)<span>个人信息共享、转让或公开披露的主要对象发生变化；</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      (4)<span>您参与个人信息处理方面的权利及其行使方式发生重大变化。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      <b><span>（五）其他</span></b>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      1.<span>您知晓并同意本隐私政策系</span><span>Gloda</span><span>相关服务条款不可分割的一部分。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      2. <span>您访问或者使用我们的服务亦受我们合作伙伴的条款约束，包括但不限于</span><a class="href" href="https://www.tiktok.com/legal/page/global/tik-tok-developer-terms-of-service/en" target="_blank"><u>TikTok<span>开发者服务条款</span></u></a><span>，其条款可直接在我们平台或着我们合作伙伴的平台下载。</span>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
      3.<span>如果您对本政策有任何疑问、意见或要求，请通过以下方式联系我们</span><span>: </span><a class="href" href="https://seller.glodastory.com/" target="_blank"><u>https://seller.glodastory.com/</u></a>
    </p>
    <p class="MsoNormal" style="margin-left:0pt;">
	&nbsp;
    </p>
    <p>
      <br>
    </p>
  </div>
</template>

<style lang="less" scoped>
.privacy {
  width: 100%;
  height: 100%;
  background: var(--bright-color);
  padding: 56px;
  padding-top: 0;
  box-sizing: border-box;
  z-index: 9999 !important;
  overflow: auto;
  &__title {
    font-size: 30px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
  }
  &__second-title {
    margin: 0 0 32px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
  }
  .href {
    color: #0000e4;
  }
}
</style>
